import { Button } from "@primitives/button";

import { useNavigate } from "react-router-dom";
import LoginForm from "@/components/auth/LoginForm";
import { useTranslation } from "react-i18next";
import { featureFlags } from "@/config/featureFlags";

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex size-full scroll-py-8 flex-col overflow-y-auto px-6 py-12 lg:w-[600px] lg:px-8">
      <div className="my-auto flex flex-col rounded-lg px-7 py-10 shadow-md sm:mx-auto sm:w-full sm:max-w-lg lg:bg-card lg:px-24">
        <img
          src="/orion-logo.svg"
          alt="ORION"
          className="mx-auto size-32 dark:invert"
        />

        <LoginForm />

        <div className="text-center text-sm">
          {t("dontHaveAccount")}
          <Button
            variant="link"
            className="text-secondary hover:no-underline"
            onClick={() => navigate("/register")}
          >
            {t("register.title")}
          </Button>
        </div>
        <Button
          variant="link"
          className="text-foreground underline"
          onClick={() => navigate("/forgotPassword")}
        >
          {t("forgotPassword")}
        </Button>
        {/* Gated off until the backend mail env vars are set per environment. */}
        {featureFlags.forgotUsername && (
          <Button
            variant="link"
            className="text-foreground underline"
            onClick={() => navigate("/forgotUsername")}
          >
            {t("forgotUsername.link")}
          </Button>
        )}
      </div>
    </div>
  );
}
